import Work1 from "../../assets/faithgoodies.png";
import Work2 from "../../assets/kelsbody.png";
import Work3 from "../../assets/chrisville.png";
import Work4 from "../../assets/crown_eagle.png";
import Work5 from "../../assets/lawsghana.png";
import Work6 from "../../assets/smartgroceries.png";
import Work7 from "../../assets/akantant.png";
import Work8 from "../../assets/pamojacare.png";
import Work9 from "../../assets/marpe_foods.png";
import Work10 from "../../assets/joyenergy.png";

export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Faith Goodies",
      category: "wordpress apps",
      url: "http://www.faithgoodies.com/"
    },
    {
      id: 2,
      image: Work2,
      title: "Kelsbody",
      category: "wordpress apps",
      url: "https://www.kelsbody.com/"
    },
    {
      id: 3,
      image: Work3,
      title: "Chrisville Energy",
      category: "apps",
      url: "https://chrisvillenergy.com/"
    },
    {
      id: 4,
      image: Work4,
      title: "Crown Eagle Petroleum",
      category: "wordpress apps",
      url: "https://cepetroleum.org/"
    },
    {
      id: 5,
      image: Work5,
      title: "Laws Ghana",
      category: "apps",
      url: "https://lawsghana.com/"
    },
    {
      id: 6,
      image: Work6,
      title: "Smart Groceries",
      category: "apps",
      url: "https://smartgroceries.org/"
    },
    {
      id: 7,
      image: Work7,
      title: "Akantant",
      category: "apps",
      url: "https://akantant.com"
    },
    {
      id: 8,
      image: Work8,
      title: "Pamoja Care Servies",
      category: "apps",
      url: "https://www.pamojacareservices.com.au/"
    },
    {
      id: 9,
      image: Work9,
      title: "Marpe Foods",
      category: "apps",
      url: "https://marpe-foods.com/"
    },
    {
      id: 10,
      image: Work10,
      title: "Joy Energy",
      category: "wordpress apps",
      url: "https://joyenergylimited.com/"
    }, 
    
  ];

  export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'wordpress apps',
    },
    {
        name: 'apps',
    },
    // {
    //     name: 'in-development',
    // },
  ];
  